/*
  NO FUGAZI — rest points for the long pages.

  Measured before this: the cap page runs 4,377 words across 17 visual breaks —
  257 words between each. The homepage manages 80. The competitor teardown put
  the sites that read well at a median of about 39. Long copy is deliberate and
  stays; what it lacked was somewhere for the eye to stop.

  Two devices, both built from what is already on the page, so nothing new has
  to be written and no photograph is needed:

  1. A CONTENTS list, built from the page's own H2s and dropped in after the
     opening section. This is the Silk Routes pattern from the teardown: it
     turns a wall into a navigable document without deleting a word. Every
     heading also gets an id, so the links are real and shareable.

  2. A STATEMENT: the first sentence of the longest remaining prose run, lifted
     out and set large. The sentence is not duplicated — it is moved — so the
     word count is unchanged and nothing is invented.

  Only runs on pages long enough to need it, and never on the homepage, which
  already has rhythm.
*/
(function () {
  'use strict';

  var MIN_WORDS = 1200;          // below this a page does not need help
  var MIN_HEADINGS = 4;          // and a contents list needs somewhere to go

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function slug(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  }

  ready(function () {
    var main = document.querySelector('#MainContent');
    if (!main) return;
    if (document.body.classList.contains('template-index')) return;

    var words = (main.textContent || '').trim().split(/\s+/).length;
    if (words < MIN_WORDS) return;

    // Only headings that actually title a section of the page body — skip the
    // page banner, and skip anything inside an accordion, a card or the footer.
    var heads = [].slice.call(main.querySelectorAll('h2')).filter(function (h) {
      if (!h.textContent.trim()) return false;
      if (h.closest('.t4s-tab-wrapper, .t4s-product-info, footer, .nf-contents')) return false;
      if (h.getBoundingClientRect().width === 0) return false;
      return true;
    });
    if (heads.length < MIN_HEADINGS) return;

    // ---- 1. contents ----
    var list = document.createElement('nav');
    list.className = 'nf-contents';
    list.setAttribute('aria-label', 'On this page');
    var inner = '<p class="nf-contents__k">On this page</p><ol class="nf-contents__l">';
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'sec-' + (slug(h.textContent) || i);
      h.style.scrollMarginTop = '90px';
      inner += '<li><a href="#' + h.id + '">' + h.textContent.trim() + '</a></li>';
    });
    list.innerHTML = inner + '</ol>';

    // place it after the first section, so the opening pitch is read first
    var firstSection = heads[0].closest('.t4s-section-inner, section, .shopify-section');
    if (firstSection && firstSection.parentNode) {
      firstSection.parentNode.insertBefore(list, firstSection);
    } else {
      heads[0].parentNode.insertBefore(list, heads[0]);
    }

    // ---- 2. statements, one per heavy section ----
    // One statement for the whole page barely moved the needle: 257 -> 234
    // words between breaks on the cap page. These pages are a handful of very
    // large blocks, so every section that runs long gets its own rest, and its
    // heading gets a rule above it so the eye registers a new topic.
    heads.forEach(function (h) {
      var sec = h.closest('.t4s-section-inner, section, .shopify-section') || h.parentNode;
      if (!sec || sec.getAttribute('data-nf-rested')) return;

      var secWords = (sec.textContent || '').trim().split(/\s+/).length;
      if (secWords < 220) return;

      var paras = [].slice.call(sec.querySelectorAll('p')).filter(function (p) {
        if (p.closest('.nf-contents, .nf-sp, .t4s-tab-wrapper, footer, .nf-cc, .nf-say')) return false;
        return (p.textContent || '').trim().split(/\s+/).length > 45;
      });
      if (!paras.length) return;
      paras.sort(function (x, y) {
        return y.textContent.trim().length - x.textContent.trim().length;
      });

      // Some sentences must never be promoted to a headline. On the product
      // pages this lifted "NO FUGAZI is a clothing manufacturer, managed from
      // London and producing in our own dedicated overseas facility" to 27px —
      // making the factory's location the loudest thing on the page. Where
      // production happens is a disclosure, not a selling point, and the four
      // artists are an "as seen on" credit, not a headline either.
      var NEVER = /overseas|dedicated facility|Che Lingo|Blanco|Grace Ajilore|King Promise|bank transfer/i;

      var p = null, m = null;
      for (var pi = 0; pi < paras.length; pi++) {
        var cand = /^(.{40,190}?[.!?])\s+(.+)$/.exec(paras[pi].textContent.trim().replace(/\s+/g, ' '));
        if (!cand) continue;
        if (NEVER.test(cand[1])) continue;
        p = paras[pi]; m = cand; break;
      }
      if (!p || !m) return;

      var say = document.createElement('p');
      say.className = 'nf-say';
      say.textContent = m[1];
      p.textContent = m[2];
      p.parentNode.insertBefore(say, p);

      sec.setAttribute('data-nf-rested', '1');
      h.classList.add('nf-sechead');
    });

    // ---- 3. fact strips ----
    // Sections that run long but have no paragraph big enough to promote a
    // sentence from get a fact strip instead: the "quiet label, loud number"
    // mark used elsewhere on the site.
    //
    // Every one of these is a fact already stated in the live copy — checked
    // before use. Nothing here is new information, it is the page's own
    // specifics pulled out where the eye needs a stop.
    var FACTS = [
      ['50 pieces',    'Minimum order'],
      ['2–3 weeks',  'Sampling'],
      ['3–8 weeks',  'Bulk after approval'],
      ['4 stages',     'Quality control'],
      ['No tech pack', 'Needed to start'],
      ['In house',     'Pattern and fit'],
      ['1–3%',        'Residual shrinkage'],
      ['Worldwide',    'Shipping'],
      ['Bank transfer','Payment']
    ];
    var used = 0;

    heads.forEach(function (h) {
      var sec = h.closest('.t4s-section-inner, section, .shopify-section') || h.parentNode;
      if (!sec) return;
      if (sec.getAttribute('data-nf-rested')) return;      // already has a statement
      if (sec.getAttribute('data-nf-strip')) return;
      if (sec.querySelector('.nf-sp, .t4s-iconbox, img')) return;  // already structured

      var secWords = (sec.textContent || '').trim().split(/\s+/).length;
      if (secWords < 260) return;

      // Do not restate something the reader is about to read anyway. The first
      // build put a "50 pieces / minimum order" strip directly above a spec row
      // saying exactly that.
      //
      // The guard is deliberately narrow: only the LABELS of nearby spec blocks
      // are compared, not the whole section. A first attempt scanned all the
      // section text and killed every strip on the page — these pages mention
      // "50 pieces" everywhere, so nothing survived, which is a filter, not a
      // fix. What actually reads as duplication is the same label appearing
      // twice within a screen of itself.
      var near = '';
      var scope = [sec];
      var nx = sec.nextElementSibling;
      for (var k = 0; k < 2 && nx; k++) { scope.push(nx); nx = nx.nextElementSibling; }
      scope.forEach(function (el) {
        el.querySelectorAll('.nf-sp__k, .nf-sp__t').forEach(function (lab) {
          near += ' ' + (lab.textContent || '');
        });
      });
      near = near.toLowerCase();

      var picks = [], tries = 0;
      while (picks.length < 3 && tries < FACTS.length) {
        var f = FACTS[(used + tries) % FACTS.length];
        tries++;
        var v = f[0].toLowerCase().replace(/[–—]/g, '-');
        if (near.indexOf(v) !== -1) continue;              // a nearby spec row already shows this value
        if (near.indexOf(f[1].toLowerCase()) !== -1) continue;
        picks.push(f);
      }
      used += tries;
      if (picks.length < 3) return;                        // nothing fresh to say

      var strip = document.createElement('div');
      strip.className = 'nf-facts';
      strip.innerHTML = picks.map(function (f) {
        return '<div class="nf-facts__i"><p class="nf-facts__v">' + f[0] +
               '</p><p class="nf-facts__k">' + f[1] + '</p></div>';
      }).join('');

      // drop it after the section's second paragraph, so it lands inside the
      // run rather than at the very top where it would read as a header
      var ps = sec.querySelectorAll('p');
      var anchor = ps[Math.min(1, ps.length - 1)];
      if (!anchor || !anchor.parentNode) return;
      anchor.parentNode.insertBefore(strip, anchor.nextSibling);

      sec.setAttribute('data-nf-strip', '1');
      h.classList.add('nf-sechead');
    });
  });
})();
